function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  width: fit-content;\n  padding: 5px;\n  margin: 3px;\n  a {\n    text-decoration: none;\n    color: ", ";\n    &:hover {\n      color: ", ";\n    }\n  }\n  &.contained {\n    &.selected {\n      background-color: ", ";\n      color: ", ";\n      border-radius: 4px;\n    }\n  }\n  &.text {\n    &.selected {\n      color: ", ";\n      border-bottom: 2px solid ", ";\n    }\n  }\n  &.menu-item {\n    a {\n      color: ", ";\n    }\n    &.selected {\n      a {\n        color: ", ";\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { defaultTheme } from '../../../utils';
/** @param text -> denotes text value
 * @param type -> represents heading, subheading or paragraph
 */

var StyledNav = styled.nav(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.text.bodyTextLight;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.primaryColor;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.primary['active'];
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.primaryColor;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.primaryColor;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.primaryColor;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.text.bodyTextDark;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.primaryColor;
});

var CustomNav = function CustomNav(_ref9) {
  var text = _ref9.text,
      variant = _ref9.variant,
      to = _ref9.to,
      target = _ref9.target,
      selected = _ref9.selected,
      rest = _objectWithoutPropertiesLoose(_ref9, ["text", "variant", "to", "target", "selected"]);

  return /*#__PURE__*/React.createElement(StyledNav, _extends({
    className: variant + " " + (window.location.pathname === to || selected ? 'selected' : '')
  }, rest), /*#__PURE__*/React.createElement("a", {
    href: to,
    target: target
  }, text));
};

CustomNav.propTypes = process.env.NODE_ENV !== "production" ? {
  text: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  variant: PropTypes.string,
  selected: PropTypes.bool
} : {};
CustomNav.defaultProps = {
  target: '_parent',
  theme: defaultTheme,
  variant: 'contained',
  selected: false
};
export default CustomNav;